
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.824 6.543a4.843 4.843 0 00-4.843-4.844 4.843 4.843 0 00-2.833 8.774c-.007.004-.013.005-.017.007a7.277 7.277 0 00-2.33 1.575 7.293 7.293 0 00-1.57 2.334 7.296 7.296 0 00-.575 2.697.156.156 0 00.157.16h1.17a.157.157 0 00.156-.152 5.828 5.828 0 011.71-3.99 5.79 5.79 0 014.132-1.717 4.843 4.843 0 004.843-4.844zm-4.843 3.36a3.36 3.36 0 110-6.72 3.36 3.36 0 010 6.72zm2.05 4.316h5.156c.086 0 .157-.07.157-.156v-1.094a.157.157 0 00-.157-.156H13.74l.922-1.174a.158.158 0 00.033-.096.157.157 0 00-.156-.156h-1.418a.319.319 0 00-.246.119l-1.338 1.701a.627.627 0 00.494 1.012zm4.688 1.25h-5.157a.157.157 0 00-.156.156v1.094c0 .086.07.156.156.156h3.448l-.922 1.174a.157.157 0 00.123.252h1.418a.319.319 0 00.246-.12l1.338-1.7a.626.626 0 00-.494-1.012z"}})])
          )
        }
      }
    